import React, { useEffect, useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import usePresentations from '../hooks/usePresentations';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
}

function HoverNavDropdown({ title, id, className, navigateTo, children, ...rest }) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const [isLgUp, setIsLgUp] = useState(
    typeof window !== 'undefined'
      ? window.matchMedia('(min-width: 992px)').matches
      : true
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(min-width: 992px)');
    const onChange = (e) => setIsLgUp(e.matches);

    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  const handleMouseEnter = () => {
    if (isLgUp) setShow(true);
  };

  const handleMouseLeave = () => {
    if (isLgUp) setShow(false);
  };

  const handleToggle = (nextShow) => {
    setShow(nextShow);
  };

  const handleSelect = () => {
    setShow(false);
  };

  const handleTitleClick = (e) => {
    if (navigateTo && isLgUp) {
      e.preventDefault();
      e.stopPropagation();
      navigate(navigateTo);
    }
  };

  const titleNode = (
    <span
      onClick={handleTitleClick}
      className="dropdown-title-link"
      style={{ cursor: navigateTo && isLgUp ? 'pointer' : 'default' }}
    >
      {title}
    </span>
  );

  return (
    <NavDropdown
      title={titleNode}
      id={id}
      className={className}
      show={show}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onToggle={handleToggle}
      onSelect={handleSelect}
      {...rest}
    >
      {children}
    </NavDropdown>
  );
}

function CustomNavbar() {
  const isMobile = useMediaQuery('(max-width: 991px)');
  const { presentationUrl, factsheetUrl, miningForumUrl } = usePresentations();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  
  const handleSubscribe = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await axios.post('https://qgold-n8n.off-chainventures.com/webhook/a0dc46f8-f87b-4678-8179-81e4ebbc06d2', {
        email: email
      });
      if (response.data && response.data.status === 'success') {
        setSubscribed(true);
      } else {
        console.error('Subscription failed:', response.data);
        alert('Subscription failed. You may already be subscribed.');
      }
    } catch (error) {
      console.error('Error subscribing:', error.response ? error.response.data : error.message);
      alert('An error occurred. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="navbar-wrapper" style={{ position: 'sticky', top: 0, zIndex: 1030, width: '100%' }}>
      <div className="navbar-top-bar" style={{ backgroundColor: '#0b1c3b', padding: '8px 0', fontFamily: 'Montserrat, sans-serif', borderBottom: '1px solid rgba(210, 181, 33, 0.3)' }}>
        <Container>
          <div className="navbar-top-bar-content" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
            {subscribed ? (
              <span className="navbar-top-bar-subscribed" style={{ color: '#d2b521', fontSize: '14px', fontWeight: 600 }}>Thank you for subscribing!</span>
            ) : (
              <>
                {isMobile ? (
                  <div style={{ width: '100%' }}>
                    <button
                      type="button"
                      onClick={() => setIsExpanded(!isExpanded)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#ffffff',
                        fontSize: '14px',
                        cursor: 'pointer',
                        padding: '0',
                        width: '100%',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                    >
                      <span>Sign up for the Latest News & PR</span>
                      <span style={{ 
                        display: 'inline-block',
                        transition: 'transform 0.3s ease',
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                      }}>▼</span>
                    </button>
                    <div style={{
                      display: 'grid',
                      gridTemplateRows: isExpanded ? '1fr' : '0fr',
                      transition: 'grid-template-rows 0.3s ease',
                      width: '100%'
                    }}>
                      <form onSubmit={handleSubscribe} className="navbar-top-bar-form" style={{
                        overflow: 'hidden',
                        minHeight: 0, 
                        display: 'flex', 
                        flexDirection: 'row',
                        alignItems: 'stretch',
                        gap: '0',
                        paddingTop: '8px'
                      }}>
                        <input
                          type="email"
                          className="navbar-top-bar-input"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          style={{
                            padding: '6px 12px',
                            fontSize: '14px',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            backgroundColor: '#ffffff',
                            color: '#0b1c3b',
                            flex: '1',
                            outline: 'none',
                            borderRight: 'none',
                            borderRadius: '2px 0 0 2px'
                          }}
                        />
                        <button
                          type="submit"
                          disabled={submitting}
                          className="navbar-top-bar-button"
                          style={{
                            padding: '6px 20px',
                            fontSize: '14px',
                            fontWeight: 600,
                            backgroundColor: '#d2b521',
                            color: '#ffffff',
                            border: '1px solid #d2b521',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            borderRadius: '0 2px 2px 0',
                            flexShrink: 0
                          }}
                        >
                          {submitting ? '...' : 'Subscribe'}
                        </button>
                      </form>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={handleSubscribe} className="navbar-top-bar-form" style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '12px', 
                    flexWrap: 'wrap', 
                    justifyContent: 'flex-end'
                  }}>
                    <span className="navbar-top-bar-text" style={{ 
                      color: '#ffffff', 
                      fontSize: '14px', 
                      whiteSpace: 'nowrap'
                    }}>Sign up for the latest News & PR</span>
                    <input
                      type="email"
                      className="navbar-top-bar-input"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      style={{
                        padding: '6px 12px',
                        fontSize: '14px',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        backgroundColor: '#ffffff',
                        color: '#0b1c3b',
                        minWidth: '200px',
                        width: 'auto',
                        outline: 'none'
                      }}
                    />
                    <button
                      type="submit"
                      disabled={submitting}
                      className="navbar-top-bar-button"
                      style={{
                        padding: '6px 20px',
                        fontSize: '14px',
                        fontWeight: 600,
                        backgroundColor: '#d2b521',
                        color: '#ffffff',
                        border: '1px solid #d2b521',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        width: 'auto',
                        marginLeft: '-12px'
                      }}
                    >
                      {submitting ? '...' : 'Subscribe'}
                    </button>
                  </form>
                )}
              </>
            )}
          </div>
        </Container>
      </div>
      <Navbar expand="lg" className="navbar">
      <Container className="navbar-container">
        <Navbar.Brand href="/">
          <img className="logo" src="/images/qgold-logo.png" alt="Q Gold logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <HoverNavDropdown
              title="About Us"
              id="company-dropdown"
              className="hover-dropdown"
              navigateTo="/company"  
            >
              <NavDropdown.Item as={Link} to="/company#about">About us</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/company#board">Board of Directors</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/company#management">Management team</NavDropdown.Item>
            </HoverNavDropdown>

            <HoverNavDropdown
              title="Projects"
              id="projects-dropdown"
              className="hover-dropdown"
            >
              <NavDropdown.Item href="/project/mine-centre">Mine Centre, Ontario, Canada</NavDropdown.Item>
              <NavDropdown.Item href="/project/quartz-mountain">Quartz Mountain, Oregon, USA</NavDropdown.Item>
            </HoverNavDropdown>

            <HoverNavDropdown
              title="Investors"
              id="investors-dropdown"
              className="hover-dropdown"
              navigateTo="/investors"
            >
              <NavDropdown.Item href={presentationUrl} target="_blank" rel="noopener noreferrer">
                Corporate Presentation
              </NavDropdown.Item>
              <NavDropdown.Item href={miningForumUrl} target="_blank" rel="noopener noreferrer">
                Mining Forum Americas 2026
              </NavDropdown.Item>
              <NavDropdown.Item href={factsheetUrl} target="_blank" rel="noopener noreferrer">
                Fact Sheet
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/investors">
                Investor Information
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/news">
                News
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/media-centre">
                Media Centre
              </NavDropdown.Item>
            </HoverNavDropdown>

            <HoverNavDropdown
              title="News & Events"
              id="news-events-dropdown"
              className="hover-dropdown"
              navigateTo="/news"
            >
              <NavDropdown.Item as={Link} to="/news">News</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/media-centre">Media Centre</NavDropdown.Item>
            </HoverNavDropdown>
          </Nav>
          
          <div 
            className="navbar-right-actions d-flex flex-column flex-lg-row align-items-start align-items-lg-center mt-3 mt-lg-0" 
            style={{ 
              gap: '20px', 
              marginLeft: isMobile ? '25px' : '20px',
              marginBottom: isMobile ? '20px' : '0'
            }}
          >
            <Link
              to="/investors#company-filings"
              className="stock-tickers d-flex flex-column"
              style={{
                color: '#ffffff',
                fontSize: '10px',
                fontWeight: '600',
                letterSpacing: '0.05em',
                lineHeight: '1.5',
                textAlign: isMobile ? 'left' : 'right',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              <span>TSXV: QGR</span>
              <span>OTCQB: QGLDF</span>
            </Link>
            <Link to="/contact" className="nav-contact-btn">
              Contact Us
            </Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
  );
}

export default CustomNavbar;
